// WhatsApp Business Configuration
export const WHATSAPP_NUMBER = '919741155118'; // +91 97411 55118

// Default message template for website inquiries
export const DEFAULT_MESSAGE = 'Hi, I am interested in construction services. Please contact me.';

/**
 * Generate WhatsApp URL with pre-filled message
 */
export const getWhatsAppUrl = (message = DEFAULT_MESSAGE) => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

/**
 * Open WhatsApp in new tab/window
 */
export const openWhatsApp = (message = DEFAULT_MESSAGE) => {
  const url = getWhatsAppUrl(message);
  window.open(url, '_blank');
};

